module.exports = __webpack_public_path__ + "static/media/anc6ru.c0268227.pdf";